import { render, staticRenderFns } from "./PaginationNavInput.vue?vue&type=template&id=2367e688&"
import script from "./PaginationNavInput.vue?vue&type=script&lang=js&"
export * from "./PaginationNavInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports